export const PAGINAS_ROUTES = {
    PAGINA_INICIO: 'inicio',
    PAGINA_ZONAFAN: 'zona-fan',
    PAGINA_CUMPLEANOS: 'cumpleanos',
    PAGINA_COMUNIONES: 'comuniones',
    PAGINA_OTROSEVENTOS: 'otros-eventos',
    PAGINA_FAQS: 'faqs',
    PAGINA_CONTACTO: 'contacto',
    PAGINA_AVISO_LEGAL: 'aviso-legal',
    PAGINA_COOKIES: 'cookies',
    PAGINA_RESERVAR: 'reservar',
}
